<template>
  <div :class="`seat-info block-info seat-component ${seatClass}`">
    <span v-if="isSelected" class="seat-info-initials">{{
      display_passenger_initials
    }}</span>
    <vb-icon v-else-if="isBlocked" name="seat_blocked" />
    <vb-icon
      v-else-if="is_suitable_for_infant_visible"
      class="seat-info-price"
      name="seat_best_for_infant"
      :color="sass('primary')"
      :size="20"
    />
    <span v-else-if="show_price" class="seat-info-price">
      <span>{{ formatted_price }}</span>
      <span class="d-none d-xl-inline d-lg-inline">{{ currencySymbol }}</span>
    </span>
  </div>
</template>

<script>
  export default {
    name: 'seat-content',
    props: {
      seatClass: {
        type: String,
        required: true,
      },
      isSelected: {
        type: Boolean,
        default: false,
      },
      isBlocked: {
        type: Boolean,
        default: false,
      },
      isAvailable: {
        type: Boolean,
        default: false,
      },
      isSuitableForInfant: {
        type: Boolean,
        default: false,
      },
      isHovered: {
        type: Boolean,
        default: false,
      },
      price: {
        type: Number,
        default: 0,
      },
      // Pre-resolved glyph (€, $, …) — computed in the seat-map mapper from
      // the seat-pricing response's currency code, so template renders stay
      // allocation-free.
      currencySymbol: {
        type: String,
        default: '',
      },
      passenger: Object,
      showSuitableForInfant: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      display_passenger_initials() {
        if (!this.passenger) return '';
        return `P${this.passenger.id}`;
      },
      formatted_price() {
        return Math.ceil(this.price);
      },
      has_price() {
        return this.price !== 0;
      },
      show_content() {
        return !this.isSelected && this.isAvailable;
      },
      is_suitable_for_infant_visible() {
        if (!this.show_content) {
          return false;
        }
        if (!this.showSuitableForInfant) {
          return false;
        }
        if (!this.isSuitableForInfant) {
          return false;
        }
        return !this.isHovered || !this.has_price;
      },
      show_price() {
        if (!this.show_content) {
          return false;
        }
        if (!this.has_price) {
          return false;
        }
        return (
          !this.showSuitableForInfant ||
          !this.isSuitableForInfant ||
          this.isHovered
        );
      },
    },
    methods: {
      sass(colorName) {
        // Pass through to parent's sass helper
        return this.$parent.sass ? this.$parent.sass(colorName) : colorName;
      },
    },
  };
</script>
